import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Card, CardBody, Row, Col, Label } from "reactstrap";
import { AvCheckbox, AvCheckboxGroup, AvField, AvForm } from "availity-reactstrap-validation";
import { adminPrefix } from "configs/routePrefix";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import SuccessModal from "components/SucessModal"
import CancelModal from "components/CancelModal"
import SalesDeveloperService from "services/Admin/SalesDeveloperService";
import Select from "react-select";
import DeveloperService from "services/Admin/DeveloperService";
import { toast } from "react-toastify";

const languages = ["en", "ar", "zh", "ru"]
const roles=[
  {label: "Send Avalibality" , value: "send_avalibality" ,status: false}, 
  {label: "Send Uploaded Recipt" , value: "send_uploaded_recipt",status: false}, 
  {label: "Send Client Information for Cash on Meeting" , value: "send_client_information_for_cash_on_meeting",status: false}, 
  {label: "Send Comparison" , value: "send_comparison", status: false}, 
  {label: "Sales Developer Send Mail for a Client" , value: "sales_developer_send_mail_for_a_client", status: false}, 
  {label: "Manage Inventory" , value: "manage_inventory", status: false}, 
  {label: "Manage Client" , value: "manage_client", status: false}, 
  {label: "Manage Client Status" , value: "manage_client_status", status: false}, 
  {label: "Manage Deals" , value: "manage_deals", status: false}, 
  {label: "Manage Deals Status"  , value: "manage_deals_status" ,status: false}, 
]
const manageCompound = [
  {label: "View" , value: "view_compound" ,status: false}, 
  {label: "Add" , value: "add_compound" ,status: false}, 
  {label: "Edit" , value: "edit_compound" ,status: false}, 
  {label: "Delete" , value: "delete_compound" ,status: false}, 
]
const initialState = {
  en: "",
  ar: "",
  ru: "",
  zh: "",
  email: "",
  phone: "",
  developer: "",
  permissions: {}
}

const CreateSalesDeveloperPage = (props) => {
  const [loading, setLoading] = useState(false)
  const salesDeveloperService = new SalesDeveloperService()
  const [formState, setFormState] = useState(initialState);
  const [modal, setModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [permissions, setPermissions]= useState({})
  const [developerOptions, setDeveloperOptions]= useState([])

  const handleRolesChange = (value, e) => {
    if (selectedRoles.includes(value)) {
      setSelectedRoles(selectedRoles.filter((val) => val !== value));
    } else {
      setSelectedRoles([...selectedRoles, value]);
    }
    setPermissions({...permissions, [value]: e})
  };

  useEffect(()=>{
    new DeveloperService().getDropDown().then(res=>{
      const newOptions = res.data.map(item => {
        return {
            label: item.name.en,
            value: item.id
        }
    })
    setDeveloperOptions(newOptions)
    })
  },[])

  const handleValidSubmit = (e, v) => {
    setLoading(true)
    let allRoles= {}
    roles.map(role=>{
      allRoles[role.value] = false
    })
    manageCompound.map(role=>{
      allRoles[role.value] = false
    })

    const data = {
      name: { en: formState.en, },
      media_id: formState.media_id,
      email: formState.email,
      phone: formState.phone,
      developer_id: formState.developer.value,
      permissions: {...allRoles, ...permissions }
    }

    languages.forEach(language => {
      if (formState[language].length) {
        data.name[language] = formState[language]
      }
    })
    
    salesDeveloperService.invite(data).then(res => {
      if (res && res.status === SuccessOk) {
        setLoading(false)
        setSuccessModal(true)
      } else {
        toast.error(res)
        setLoading(false)
      }
    })
  };

  const handleFieldChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Sales Developer</title>
        </MetaTags>
        <Container fluid>
          <h4>
            Invite Sales Developer
          </h4>
          <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v);
            }}>
            <Card className="w-100 mt-4">
              <CardBody>
                <Row className="mb-4">
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        errorMessage="This field is required"
                        name='en'
                        label="Sales Developer Name (en)"
                        placeholder={"English"}
                        className='form-control'
                        required
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='ar'
                        label="Sales Developer Name (ar)"
                        className='form-control'
                        placeholder={"العربية"}
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='ru'
                        label="Sales Developer Name (ru)"
                        placeholder={"Русский"}
                        className='form-control'
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='zh'
                        placeholder={"中文"}
                        label="Sales Developer Name (zh)"
                        className='form-control'
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <Label>Developer</Label>
                      <Select
                          placeholder='Select'
                          options={developerOptions}
                          onChange={data => setFormState({ ...formState, developer: data })}
                          value={formState.developer}
                          required
                      />
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        name='email'
                        label="Email"
                        validate={{
                          required: {value: true, errorMessage: 'This Field is required'},
                          pattern: {value: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$', errorMessage: "Email format is invalid"}
                        }}
                        className='form-control'
                        required
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        placeholder={"salesdeveloper@gmail.com"}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='mb-3'>
                      <AvField
                        label= "Phone"
                        name='phone'
                        placeholder={"123456789"}
                        className='form-control'
                        validate={{
                          required: {value: true, errorMessage: 'This Field is required'},
                          pattern: {value: '^01[0-9]+$', errorMessage: "The Phone format is invalid"},
                          minLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                          maxLength: {value: 11, errorMessage: 'The Phone must be 11 characters'},
                        }}
                        required
                        onChange={(e) => handleFieldChange(e)}
                        bsSize="lg"
                        type="number"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Label>Select Roles</Label>
                    <AvCheckboxGroup inline name="roles"
                        required
                        validate={{min: {value: 1}}}>
                      <Row>
                      <label className="text-muted mt-3 mb-0">Manage Compound</label>
                      {manageCompound?.map((role, index)=>{
                        return <Col md={3} className='mb-2'>
                          <AvCheckbox 
                            key={index}
                            label={role.label}
                            value={role.value}
                            checked={selectedRoles.includes(role.value)}
                            onChange={(e) => handleRolesChange(role.value,e.target.checked)}/>
                        </Col>
                      })}
                      <label className="text-muted mt-1 mb-0">Others</label>
                      {roles?.map((role, index)=>{
                        return <Col md={6}>
                          <AvCheckbox 
                            key={index}
                            label={role.label}
                            value={role.value}
                            checked={selectedRoles.includes(role.value)}
                            onChange={(e) => handleRolesChange(role.value,e.target.checked)}/>
                        </Col>
                      })}
                      </Row>
                    </AvCheckboxGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Row className="d-flex justify-content-between pb-4">
              <Col>
                <button
                  type="button"
                  className="btn btnUpload btnHeight px-4"
                  onClick={() => {
                    setModal(true)
                  }}
                  size={"lg"}>
                  Cancel
              </button>
              </Col>
              <Col>
                <button
                  type='submit'
                  className="btn btn-success btnHeight px-4 float-end"
                  size={"lg"}
                  disabled={loading ? true : false}

                >
                  Submit
                </button>
              </Col>
            </Row>
            <CancelModal modal={modal}
              setModal={setModal}
              goBackHandler={() => props.history.push(`${adminPrefix}/sales-developer`)}
            />
          </AvForm>
          {successModal && <SuccessModal modal={successModal}
            message="Invited Sales Developer Successfully"
            onClick={() => {
              props.history.push(`${adminPrefix}/sales-developer`)
            }}
            title="Invite Sales Developer" />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateSalesDeveloperPage;
